import { useMemo } from "react"

import { getTextColor } from "../utils/shared-utils"

// Custom hook for smart text color selection
export const useContrastText = (backgroundColor, fallbackColor = "#000000") =>
  useMemo(() => getTextColor(backgroundColor, fallbackColor), [backgroundColor, fallbackColor])

// Hook for getting multiple text colors for different elements
export const useContrastTexts = (backgroundColor, options = {}) => {
  const { primaryFallback = "#000000", secondaryFallback = "#6B7280", mutedFallback = "#9CA3AF" } = options

  return useMemo(() => {
    const primaryText = getTextColor(backgroundColor, primaryFallback)

    // For secondary and muted text, we can either use the same contrast logic
    // or create slightly different shades based on the primary text color
    let secondaryText, mutedText

    if (primaryText === "#FFFFFF") {
      // If primary text is white, use lighter grays for secondary/muted
      secondaryText = "#E5E7EB"
      mutedText = "#D1D5DB"
    } else {
      // If primary text is black, use darker grays for secondary/muted
      secondaryText = "#6B7280"
      mutedText = "#9CA3AF"
    }

    return {
      primary: primaryText,
      secondary: secondaryText,
      muted: mutedText
    }
  }, [backgroundColor, primaryFallback, secondaryFallback, mutedFallback])
}
